// Returns a promise.
import axios from 'axios'

export const instance = axios.create({ timeout: 15000 })

instance.interceptors.request.use(request => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(
      `%c  ${request.method} : ${request.url}`,
      'background: #222; color: #bada55'
    )
  }
  return request
})
exports.module = { instance }

export default url => axios(url)



/** WEBPACK FOOTER **
 ** ./src/lib/api.js
 **/